export const tool = {
  name: 'textaco',
  description: 'A tool that modifies the 3D model’s material or texture based on a prompt.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      prompt: {
        type: 'string',
        description: 'Instructions to change the material or texture of the 3D model.',
      },
      message: {
        type: 'string',
        default: 'Change model texture',
      },
    },
    required: ['prompt', 'message'],
  },
};
